/* Globales JS — minimal, vanilla. */
(function () {
  'use strict';

  // Header scroll
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 4) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu toggle
  const menuToggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.site-header__nav');
  const overlay = document.querySelector('.menu-overlay');

  if (menuToggle && nav) {
    const openMenu = () => {
      nav.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.classList.add('menu-is-open');
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.setAttribute('aria-label', 'Menü schließen');
    };

    const closeMenu = () => {
      nav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('menu-is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Menü öffnen');
    };

    // Burger-Klick: Toggle
    menuToggle.addEventListener('click', () => {
      if (nav.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Klick auf Overlay (dunkler Hintergrund) schließt
    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    // Klick auf einen Menülink schließt das Menü
    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    // ESC-Taste schließt das Menü
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Beim Wechsel auf Desktop-Breite (>900px) Menü zurücksetzen
    const desktopQuery = window.matchMedia('(min-width: 901px)');
    desktopQuery.addEventListener('change', (e) => {
      if (e.matches) closeMenu();
    });
  }

  // FAQ accordions
  document.querySelectorAll('.faq__item').forEach((item) => {
    const trigger = item.querySelector('.faq__trigger');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      item.classList.toggle('is-open');
    });
  });

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
  }

  // Product page: variant click → swap main image
  const variantBtns = document.querySelectorAll('.product__variant');
  const mainImage = document.querySelector('.product__main-image img');
  variantBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      variantBtns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const newSrc = btn.getAttribute('data-image');
      if (newSrc && mainImage) mainImage.src = newSrc;
    });
  });

  // Product page: thumbnail swap
  document.querySelectorAll('.product__thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product__thumb').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.querySelector('img')?.src;
      if (src && mainImage) mainImage.src = src;
    });
  });

  // Quantity inputs
  document.querySelectorAll('.qty-input').forEach((wrap) => {
    const input = wrap.querySelector('input');
    const minus = wrap.querySelector('[data-qty="minus"]');
    const plus = wrap.querySelector('[data-qty="plus"]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    plus?.addEventListener('click', () => {
      const v = parseInt(input.value || '1', 10) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
